import Vue from 'vue'
import Router from 'vue-router'

const Home = () => import('@/views/index')
const kidHome = () => import('@/views/kid-home')
const HomeOld = () => import('@/views/old')
const newChannel = () => import('@/views/lp/new-channel')
const newChannel2020Sem2 = () => import('@/views/lp/new-channel-2020sem2')
const newChannel2020Sem3 = () => import('@/views/lp/new-channel-2020sem3')
const newChannelSempdu = () => import('@/views/lp/new-channel-sempdu')
const newChannel2020Sem4 = () => import('@/views/lp/new-channel-2020sem4')
const newChannelCode = () => import('@/views/lp/new-channel-code')
const newPay2 = () => import('@/views/lp/new-pay2')
const newChannelCode56 = () => import('@/views/lp/new-channel-code56')
const newChannelCode78 = () => import('@/views/lp/new-channel-code78')
const newChannel9 = () => import('@/views/lp/new-channel9')
const LpSubject = () => import('@/views/lp/subject')
const G12 = () => import('@/views/lp/g12')
const BdSl = () => import('@/views/lp/bd-sl')
const BdYw = () => import('@/views/lp/bd-yw')
const appointSuccess1v1 = () => import('@/views/appointment-success-1v1')
const appointSuccessPeilian = () => import('@/views/appointment-success-peilian')
const appointSuccessKid = () => import('@/views/appointment-success-kid')
const appointSuccessKidNot86 = () => import('@/views/appointment-success-kid-not86')
const appointSuccessOversea = () => import('@/views/appointment-success-oversea')
const appointSuccessWxbind = () => import('@/views/appointment-success-wxbind')
const appointSuccessLittleGenius = () => import('@/views/appointment-success-little-genius')
const ComponentNotFound = () => import('@/views/404')
const appointSuccess = () => import('@/views/appointment-success')
const septemberActivity = () => import('@/views/september-activity')
const pinYin = () => import('@/views/lp/pinyin')
const newMediaYw = () => import('@/views/lp/new-media-yw')
const courseDetailMath = () => import('@/views/course-detail/math/index')
const courseDetailChinese = () => import('@/views/course-detail/chinese/index')
const courseDetailStudy = () => import('@/views/course-detail/study/index')
const courseDetailEnglish = () => import('@/views/course-detail/english/index')
const courseDetail = () => import('@/views/course-detail/main')
const courseDetailMathApp = () => import('@/views/course-detail/math/index-app')
const courseDetailChineseApp = () => import('@/views/course-detail/chinese/index-app')
const courseDetailStudyApp = () => import('@/views/course-detail/study/index-app')
const courseDetailEnglishApp = () => import('@/views/course-detail/english/index-app')
// 五月活动
const mayActivity19 = () => import('@/views/activity/mayActivity/index')
//六月活动
const juneActivity19 = () => import('@/views/activity/juneActivity/index')
//七月活动
const julyActivity19 = () => import('@/views/activity/julyActivity/index')
// 八月活动
const augustActivity = () => import('@/views/activity/augustActivity/index')
// 九月活动
const septemberActivity19 = () => import('@/views/activity/septemberActivity/index')
//十月活动
const octoberActivity = () => import('@/views/activity/octoberActivity/index')
//十一月活动
const novemberActivity = () => import('@/views/activity/novemberActivity/index')
//三月活动B
const common2002 = () => import('@/views/activity/common20/second')

const zmkidActivity = () => import('@/views/activity/zmkid-activity/index')
const zmkidActivity2 = () => import('@/views/activity/zmkid-activity/second')
const zmkidActivity618 = () => import('@/views/activity/zmkid-activity618/index')
const fwhWenben = () => import('@/views/fwh-wenben')
const sem = () => import('@/views/lp/sem')
const C0 = () => import('@/views/lp/c0')
const newC0 = () => import('@/views/lp/newc0')
const newC1 = () => import('@/views/lp/newc1')
const D0 = () => import('@/views/lp/d0')
const E0 = () => import('@/views/lp/e0')
const F0 = () => import('@/views/lp/f0')
const hw = () => import('@/views/lp/hw')
const bdqk = () => import('@/views/lp/bd-qk')
const bdqka = () => import('@/views/lp/bd-qka')
const dbxxl = () => import('@/views/course-detail/study1/index') // http://jira.zmops.cc/browse/MWEB-1716
const association = () => import('@/views/lp/association')
const xxlyw = () => import('@/views/xxl/yw')
const xxlyw2 = () => import('@/views/xxl/yw2')
const oversea = () => import('@/views/activity/oversea/oversea')
const oversea2 = () => import('@/views/activity/oversea/oversea2')
const sem7 = () => import('@/views/activity/oversea/2020sem7')
const courseShopCommodity = () => import('@/views/course-shop-commodity')
const sem5 = () => import('@/views/lp/2020sem5')
const traditionalChinese = () => import('@/views/year2020/landingPage/traditionalLanding/chinese')
const traditionalMath = () => import('@/views/year2020/landingPage/traditionalLanding/math')

import { queryObj } from '@/utils/util'
import year2020 from './year2020'
import channel from './channel'

Vue.use(Router)


const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/kid',
      name: 'kid-home',
      component: kidHome
    },
    {
      path: '/old',
      name: 'home-old',
      component: HomeOld
    },
    {
      path: '/appointment-success-1v1',
      name: 'appointment-success-1v1',
      component: appointSuccess1v1
    },
    {
      path: '/appointment-success-peilian',
      name: 'appointment-success-peilian',
      component: appointSuccessPeilian
    },
    {
      path: '/appointment-success-kid',
      name: 'appointment-success-kid',
      component: appointSuccessKid
    },
    {
      path: '/appointment-success-kid-not86',
      name: 'appointment-success-kid-not86',
      component: appointSuccessKidNot86
    },
    {
      path: '/appointment-success-oversea',
      name: 'appointment-success-oversea',
      component: appointSuccessOversea
    },
    {
      path: '/appointment-success-wxbind',
      name: 'appointment-success-wxbind',
      component: appointSuccessWxbind
    },
    {
      path: '/appointment-success-little-genius',
      name: 'appointment-success-little-genius',
      component: appointSuccessLittleGenius
    },
    {
      path: '/appointment-success',
      name: 'appointSuccess',
      component: appointSuccess
    },
    {
      path: '/september-activity',
      name: 'septemberActivity',
      component: septemberActivity
    },

    {
      path: '/course-math',
      name: 'coruseDetailMath',
      component: courseDetailMath
    },
    {
      path: '/course-chinese',
      name: 'courseDetailChinese',
      component: courseDetailChinese
    },
    {
      path: '/course-study',
      name: 'courseDetailStudy',
      component: courseDetailStudy
    },
    {
      path: '/pinyin',
      name: 'pinyin',
      component: pinYin
    },
    {
      path: '/lp/bd-xxl',
      name: 'bd-xxl',
      component: dbxxl
    },
    {
      path: '/lp/bd-xxl1',
      name: 'bd-xxl1',
      component: dbxxl
    },
    // {
    //   path: '/course-english',
    //   name: 'courseDetailEnglish',
    //   component: courseDetailEnglish
    // },
    {
      path: '/course-detail',
      name: 'courseDetail',
      component: courseDetail
    },

    {
      path: '/course-math-app',
      name: 'coruseDetailMathApp',
      component: courseDetailMathApp,
      meta: {
        title: '数理逻辑训练'
      }
    },
    {
      path: '/course-chinese-app',
      name: 'courseDetailChineseApp',
      component: courseDetailChineseApp,
      meta: {
        title: '语文'
      }
    },
    {
      path: '/course-study-app',
      name: 'courseDetailStudyApp',
      component: courseDetailStudyApp,
      meta: {
        title: '学习力'
      }
    },
    {
      path: '/course-english-app',
      name: 'courseDetailEnglisgApp',
      component: courseDetailEnglishApp,
      meta: {
        title: '英语'
      }
    },
    {
      path: '/fwh-wenben',
      name: 'fwhWenben',
      component: fwhWenben
    },
    {
      path: '/lp/a1/:path',
      name: 'a1subject',
      component: LpSubject,
      meta: {
        formType: 'common',
        subject: 'chinese'
      }
    },
    {
      path: '/lp/a2/:path',
      name: 'a2subject',
      component: LpSubject,
      meta: {
        formType: 'common',
        subject: 'math',
      }
    },
    {
      path: '/lp/b1/:path',
      name: 'b1subject',
      component: LpSubject,
      meta: {
        formType: 'pre-mobile',
        subject: 'chinese'
      }
    },
    {
      path: '/lp/b2/:path',
      name: 'b2subject',
      component: LpSubject,
      meta: {
        formType: 'pre-mobile',
        subject: 'math',
      }
    },
    {
      path: '/lp/g1',
      name: 'g1subject',
      component: G12,
      meta: {
        formType: 'common',
        subject: 'chinese'
      }
    },
    {
      path: '/lp/g2',
      name: 'g2subject',
      component: G12,
      meta: {
        formType: 'common',
        subject: 'math',
      }
    },
    {
      path: '/lp/bd-sl',
      name: 'bdSl',
      component: BdSl,
      meta: {
        formType: 'pre-mobile',
        subject: 'math'
      }
    },
    {
      path: '/lp/bd-sl1',
      name: 'bdSl1',
      component: BdSl,
      meta: {
        formType: 'pre-mobile',
        subject: 'math'
      }
    },
    {
      path: '/lp/bd-yw',
      name: 'bdYw',
      component: BdYw,
      meta: {
        formType: 'pre-mobile',
        subject: 'chinese'
      }
    },
    {
      path: '/lp/bd-yw1',
      name: 'bdYw1',
      component: BdYw,
      meta: {
        formType: 'pre-mobile',
        subject: 'chinese'
      }
    },
    {
      path: '/lp/bd-yw2',
      name: 'bdYw2',
      component: BdYw,
      meta: {
        formType: 'pre-mobile',
        subject: 'chinese'
      }
    },
    {
      path: '/lp/c0',
      name: 'c0',
      component: C0
    },
    {
      path: '/lp/c0/mpwm',
      name: 'c0-mpwm',
      component: C0
    },
    {
      path: '/lp/c0/gdtwm',
      name: 'c0-gdtwm',
      component: C0
    },
    {
      path: '/lp/c0/wyxw',
      name: 'c0-wyxw',
      component: C0
    },
    {
      path: '/lp/c0/wb_ld01',
      name: 'c0-wb_ld01',
      component: C0
    },
    {
      path: '/lp/c0/uc_qs01',
      name: 'c0-uc_qs01',
      component: C0
    },
    {
      path: '/lp/c0/uc_qs02',
      name: 'c0-uc_qs02',
      component: C0
    },
    {
      path: '/lp/c0/xxl',
      name: 'c0-xxl',
      component: newC0
    },
    {
      path: '/lp/c0/sem',
      name: 'c0-sem',
      component: newC0
    },
    {
      path: '/lp/c1/xxl',
      name: 'c1-xxl',
      component: newC1
    },
    {
      path: '/lp/c1/sem',
      name: 'c1-sem',
      component: newC1
    },
    {
      path: '/lp/d0',
      name: 'd0',
      component: D0
    },
    {
      path: '/lp/d0/wyxw',
      name: 'd0-wyxw',
      component: D0
    },
    {
      path: '/lp/d0/mpwm',
      name: 'd0-mpwm',
      component: D0
    },
    {
      path: '/lp/d0/gdtwm',
      name: 'd0-gdtwm',
      component: D0
    },
    {
      path: '/lp/d0/wb_ld01',
      name: 'd0-wb_ld01',
      component: D0
    },
    {
      path: '/lp/e0',
      name: 'e0',
      component: E0
    },
    {
      path: '/lp/f0',
      name: 'f0',
      component: F0
    },
    {
      path: '/lp/hw',
      name: 'hw',
      component: hw
    },
    {
      path: '/lp/association',
      name: 'association',
      component: association
    },
    {
      path: '/lp/sem',
      name: 'sem',
      component: sem
    },
    {
      path: '/may-activity-2019',
      name: 'mayActivity19',
      component: mayActivity19
    },
    {
      path: '/june-activity-2019',
      name: 'juneActivity19',
      component: juneActivity19
    },
    {
      path: '/july-activity-2019',
      name: 'julyActivity19',
      component: julyActivity19
    },
    {
      path: '/august-activity-2019',
      name: 'augustActivity',
      component: augustActivity
    },
    {
      path: '/september-activity-2019',
      name: 'septemberActivity19',
      component: septemberActivity19
    },
    {
      path: '/october-activity-2019',
      name: 'octoberActivity',
      component: octoberActivity
    },
    {
      path: '/november-activity-2019',
      name: 'novemberActivity19',
      component: novemberActivity
    },
    {
      path: '/zmkid-activity',
      name: 'zmkid-activity',
      component: zmkidActivity
    },
    {
      path: '/zmkid-activity2',
      name: 'zmkid-activity2',
      component: zmkidActivity2
    },
    {
      path: '/zmkid-activity618',
      name: 'zmkid-activity618',
      component: zmkidActivity618
    },
    {
      path: '/zmkid-activity02',
      name: 'zmkid-activity02',
      component: common2002
    },
    {
      path: "/lp/bd-qk",
      component: bdqk,
      name: "bdqk",
      meta: {
        formType: 'pre-mobile',
      }
    },
    {
      path: "/lp/bd-qk1",
      component: bdqk,
      name: "bdqk1",
      meta: {
        formType: 'pre-mobile',
      }
    },
    {
      path: "/lp/bd-qka",
      component: bdqka,
      name: "bdqka"
    },
    {
      path: '/new-channel1',
      name: 'august-kid-0815',
      component: newChannel
    },
    {
      path: '/new-channel2',
      name: 'august-kid-test01',
      component: newChannel
    },
    {
      path: '/2020sem1',
      name: '2020sem1',
      component: newChannel
    },
    {
      path: '/2020sem2',
      name: '2020sem2',
      component: newChannel2020Sem2
    },
    {
      path: '/2020sem3',
      name: '2020sem3',
      component: newChannel2020Sem3
    },
    {
      path: '/sempdu',
      name: 'sempdu',
      component: newChannelSempdu
    },
    {
      path: '/semhdu',
      name: 'semhdu',
      component: newChannel2020Sem4
    },
    {
      path: '/2020sem5',
      name: '2020sem5',
      component: sem5
    },
    {
      path: '/new-channel3',
      name: 'kid-test03',
      component: newChannelCode
    },
    {
      path: '/new-pay2',
      name: 'new-pay2',
      component: newPay2
    },
    {
      path: '/new-channel4',
      name: 'kid-test04',
      component: newChannelCode
    },
    {
      path: '/new-channel5',
      name: 'kid-test05',
      component: newChannelCode56
    },
    {
      path: '/new-channel6',
      name: 'kid-test06',
      component: newChannelCode56
    },
    {
      path: '/hwxxl-channel5',
      name: 'hwxxl-channel5',
      component: newChannelCode56
    },
    {
      path: '/xxl/yw',
      name: 'xxlyw',
      component: xxlyw
    },
    {
      path: '/xxl/yw2',
      name: 'xxlyw2',
      component: xxlyw2
    },
    {
      path: '/newmedia-yw',
      name: 'newmedia-yw',
      component: newMediaYw
    },
    {
      path: '/new-channel7',
      name: 'kid-test07',
      component: newChannelCode78
    },
    {
      path: '/new-channel8',
      name: 'kid-test08',
      component: newChannelCode78
    },
    {
      path: '/new-channel9',
      name: 'kid-test09',
      component: newChannel9
    },
    {
      path: '/new-channel9-introduction',
      name: 'new-channel9-introduction',
      component: newChannel9
    },
    {
      path: '/hwxxl-channel9',
      name: 'hwxxl-channel9',
      component: newChannel9
    },
    {
      path: '/oversea',
      name: 'oversea',
      component: oversea
    },
    {
      path: '/oversea3',
      name: 'oversea3',
      component: oversea
    },
    {
      path: '/oversea4',
      name: 'oversea4',
      component: oversea
    },
    {
      path: '/oversea5',
      name: 'oversea5',
      component: oversea
    },
    {
      path: '/oversea5-01',
      name: 'oversea5-01',
      component: oversea
    },
    {
      path: '/oversea-xxl1',
      name: 'oversea-xxl1',
      component: oversea
    },
    {
      path: '/oversea-xxl2',
      name: 'oversea-xxl2',
      component: oversea
    },
    {
      path: '/oversea-xxl3',
      name: 'oversea-xxl3',
      component: oversea
    },
    {
      path: '/oversea2',
      name: 'oversea2',
      component: oversea2
    },
    {
      path: '/2020sem7',
      name: '2020sem7',
      component: sem7
    },
    {
      path: '/course-shop/commodity',
      name: 'courseShopCommodity',
      component: courseShopCommodity
    },
    {
      path: '/nineActivity',
      name: 'nineActivity',
      beforeEnter (to, from, next) {
        const query = window.location.search
        const param = query.includes('?') ? '&' : '?'
        const str = `${query}${param}from=zhangmenkid`

        let baseUrl, redirectUrl
        if (process.env.NODE_ENV === 'production') {
          baseUrl = 'http://wx-zxjy.zm-19.top/api/learningCenter/wechatAuth'
          redirectUrl = 'https://h5.abc-34.xyz/nineActivity'
        } else {
          baseUrl = 'http://wx-zxjy-test.zhangmen.com/api/learningCenter/wechatAuth'
          redirectUrl = 'https://buy.zmtest.net/nineActivity'
        }
        redirectUrl = encodeURIComponent(`${redirectUrl}${str}`)
        const finalUrl = `${baseUrl}?redirect_url=${redirectUrl}`
        window.location.href = finalUrl;
        next()
      }
    },
    {
      path: '*',
      component: ComponentNotFound
    },
    ...year2020,
    ...channel
  ]
})


router.beforeEach((to, from, next) => {
  if (from.name) {
    // 主动触发百度埋点事件
    const { _hmt } = window
    _hmt && _hmt.push(['_trackPageview', to.path]);
  }
  next()
})

router.afterEach((to, from) => {
  setTimeout(() => {
    if (queryObj().ABTestUrl) {
      ZMSDK.onEvent("ABTestUrl", `${window.location.origin}${window.location.pathname}`, {
        ABTestUrl: decodeURIComponent(queryObj().ABTestUrl)
      });
    }
  }, 500)
})

export default router;
